import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faXmark, faDollarSign
} from '@fortawesome/free-solid-svg-icons';

import { currency } from 'app/src/utils/stringHelpers';

import Counter from './Counter';
import { UPDATE_SALE_ASSET } from './queries';

const Container = styled(View)`
  flex-direction: row;
  justify-content: space-around;
`;

const BidFunctions = ({ saleAsset, setShowSaleHistory }) => {
  const [showModal, setShowModal] = useState();
  const [updateSaleAsset] = useMutation(UPDATE_SALE_ASSET, {
    onCompleted: () => setShowModal(false)
  });

  const stockNumber = saleAsset.asset.stockNumber;
  const price = saleAsset.activeOffer.price;

  const updateOffer = offerAttributes => {
    updateSaleAsset({
      variables: { id: saleAsset.id, offerAttributes }
    });
  };

  const acceptConfirm =
    `Click OK to ACCEPT this bid of ${currency(price)} for ${stockNumber}`;

  const accept = () => {
    if (confirm(acceptConfirm)) {
      updateOffer({ result: 'Sold' });
    }
  };

  const declineConfirm =
    `Click OK to DECLINE this bid of ${currency(price)} for ${stockNumber}`;

  const decline = () => {
    if (confirm(declineConfirm)) {
      updateOffer({ result: 'Declined' });
    }
  };

  return (
    <>
      <Container>
        <Pressable onPress={accept}>
          <FontAwesomeIcon
            icon={faCheck}
            color="green"
            size="lg"
            title="Accept"
          />
        </Pressable>
        <Pressable onPress={decline}>
          <FontAwesomeIcon
            icon={faXmark}
            color="red"
            size="lg"
            title="Decline"
          />
        </Pressable>
        <Pressable onPress={() => setShowModal(true)}>
          <FontAwesomeIcon
            icon={faDollarSign}
            color="black"
            size="lg"
            title="Counter"
          />
        </Pressable>
      </Container>
      {showModal && (
        <Counter
          saleAsset={saleAsset}
          setShowModal={setShowModal}
          updateOffer={updateOffer}
          setShowSaleHistory={setShowSaleHistory}
        />
      )}
    </>
  );
};

export default BidFunctions;
